<div class="overflow-hidden rounded-md border border-solid border-gray-400">
  <div class="bg-gray-200 p-2 font-bold">
    {{ title() }}
  </div>

  @for (row of treatmentItems(); track row.description) {
    <div class="flex flex-col border-t border-solid border-gray-200 p-2">
      <div class="flex justify-between">
        <span class="font-medium opacity-90">{{ row.description }}</span>
        <span class="text-right text-sm opacity-80">
          {{ row.quantity }} x {{ row.price | currency }}
        </span>
      </div>

      @if (enableComments()) {
        <details>
          <summary class="text-primary-500 cursor-pointer select-none text-sm">
            Add comment
          </summary>
          <textarea
            #autosize="cdkTextareaAutosize"
            #commentInput
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            cdkAutosizeMaxRows="4"
            class="mt-1 w-full resize-y rounded border border-solid p-1"
            placeholder="Add comment (optional)"
            (input)="
              commentChange.emit({ uid: row.uid, comment: commentInput.value })
            "
          ></textarea>
        </details>
      }
    </div>
  }
</div>
